import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SG_APP_DTL_ITM_LIST,
    SF_APP_DTL_ITM,
    SF_APP_DTL_ITM_VHCL,
    SF_APP_DTL_ITM_FRMS,
    SF_APP_DTL_ITM_SEED,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";
import { SF_APP_DTL_ADD_ITM, SF_APP_RGST_OFCR_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppAddItmService";
import { APP_DTL_ADD_ITM } from "./APP_DTL_ADD_ITM";
import { APP_RGST_OFCR_ADD_ITM } from "./APP_RGST_OFCR_ADD_ITM";

export const APP_DTL_ITM = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const [visible, setVisible] = useState(false);
    const [vhcl, setVhcl] = useState(false); // Item Enter vehicle information/display detailed information !== Item 차량 정보 입력/상세 정보 표시 ==!
    const [frms, setFrms] = useState(false); // Item Enter Fire Arms information/display detailed information !== Item 총기 정보 입력/상세 정보 표시 ==!
    const [seed, setSeed] = useState(false); // Item Enter Seed information/display detailed information !== Item 종자 정보 입력/상세 정보 표시 ==!

    const [addItm, setAddItm] = useState(false);
    const [itemNo, setItemNo] = useState(null);

    const ofcrAddItmChangedRef = useRef<boolean>(props.ofcrAddItmChanged);


    const form = {
        appDtlItm: useForm({
            defaultSchema: SF_APP_DTL_ITM,
        }),
        appDtlItmVhcl: useForm({
            defaultSchema: SF_APP_DTL_ITM_VHCL,
        }),
        appDtlItmFrms: useForm({
            defaultSchema: SF_APP_DTL_ITM_FRMS,
        }),
        appDtlItmSeed: useForm({
            defaultSchema: SF_APP_DTL_ITM_SEED,
        }),
        appDtlAddItm: useForm({
            defaultSchema: SF_APP_DTL_ADD_ITM,
        }),
        appDtlOfcrAddItm: useForm({
            defaultSchema: SF_APP_RGST_OFCR_ADD_ITM,
        }),
    };

    /*
     * Application Item List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Application Item List !== 신청서 아이템 목록 ==!
        appDtlItmList: useGrid({
            defaultSchema: SG_APP_DTL_ITM_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_appItmLst: {
            head: {},
            cell: {
                rowItmNo: (gridProps: any) => {
                    const { binding, rowValues, value } = gridProps;
                    const param = {
                        appId: props.state.appId,
                        itmId: rowValues.itmId,
                        rowItmNo: rowValues.rowItmNo,
                    };

                    return (
                        <Layout direction="col" gap={1}>
                            <button
                                className="underline"
                                onClick={() => {
                                    if(ofcrAddItmChangedRef.current) {
                                        modal.openModal({content: "msg.osc.00144"}); // Unsaved data exists. Save first and then try again. !== 저장하지 않은 데이터가 존재합니다. 먼저, 저장하고 다시 시도해주시기 바랍니다. ==!
                                        return;
                                    }

                                    handler.setDefaultState();
                                    handler.getAppItmInfo(param);
                                }}
                            >
                                {`${rowValues.rowItmNo}`}
                            </button>
                        </Layout>
                    );
                },
            },
            edit: {},
        },
    };

    /*
     * Application Item Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getAppItmList: useFetch({
            api: (page = grid.appDtlItmList.page) => {
                return COMN_APIS.getAppItmList({ ...props.state }, page, grid.appDtlItmList.size);
            },
            enabled: !!props.state,
            key: [grid.appDtlItmList.page, grid.appDtlItmList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: props.state,
                    page: grid.appDtlItmList.page,
                    size: data.appItmList.page.totalSize,
                });
            },
            onError: () => {},
            showToast: false,
        }),
        // Get Application Itm Information !== 신청서 품목 정보 조회 ==!.
        getAppItmInfo: useFetch({
            api: (data) => COMN_APIS.getAppItmInfo(data),
            onSuccess: (data) => {
                form.appDtlItm.setValues(data.appItmInfo.content.osceAppItmDDto);
                setVisible(true);

                setItemNo(data.appItmInfo.content.osceAppItmDDto.itmNo);
                setAddItm(true);

                if (!comnUtils.isEmptyObject(data.appItmInfo.content.osceAppVhclDDto)) {
                    setVhcl(true);
                    form.appDtlItmVhcl.setValues(data.appItmInfo.content.osceAppVhclDDto);
                } else if (!comnUtils.isEmptyObject(data.appItmInfo.content.osceAppFrmsDDto)) {
                    setFrms(true);
                    form.appDtlItmFrms.setValues(data.appItmInfo.content.osceAppFrmsDDto);
                } else if (!comnUtils.isEmptyObject(data.appItmInfo.content.osceAppSeedDDto)) {
                    setSeed(true);
                    form.appDtlItmSeed.setValues(data.appItmInfo.content.osceAppSeedDDto);
                }
            },
            onError: (error) => {},
            showToast: false,
        }),
    };

    /*
     * Application Item Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            handler.getAppItmList();
        },
        // Get Application Item List !== 신청서 품목 목록 조회 ==!
        getAppItmList: (page: number = 0) => {
            grid.appDtlItmList.setPage(page);
            fetch.getAppItmList.fetch(page);
        },
        // Get Application Item Information !== 신청서 품목 정보 조회 ==!
        getAppItmInfo: async (data: any) => {
            await fetch.getAppItmInfo.fetch(data);
        },
        setDefaultState: async () => {
            setVisible(false);
            setVhcl(false);
            setFrms(false);
            setSeed(false);
            setAddItm(false);
        },
    };

    useEffect(() => {
        ofcrAddItmChangedRef.current = props.ofcrAddItmChanged;
    }, [props.ofcrAddItmChanged]);

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_ITM_LST"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group>
                            <Group.Body>
                                <Grid
                                    {...grid.appDtlItmList.grid}
                                    data={fetch.getAppItmList.data?.appItmList}
                                    render={render.grid_appItmLst}
                                />
                            </Group.Body>
                        </Group>
                    </Layout>
                    {visible && (
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_ITM"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.appDtlItm.schema.rowItmNo} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItm.schema.hsNm} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItm.schema.itmDesc} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItm.schema.godsStatNm} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_MESR_QTY_UT" />
                                    <Group.Field size={4}>
                                        <Group.Control
                                            {...form.appDtlItm.schema.itmQtyUtNm}
                                            controlSize={4}
                                            disabled={true}
                                        />
                                        <Group.Control {...form.appDtlItm.schema.itmQty} disabled={true} />
                                    </Group.Field>

                                    <Group.Label label="L_SUPP_QTY" />
                                    <Group.Field size={4}>
                                        <Group.Control
                                            {...form.appDtlItm.schema.itmSuppQtyUtNm}
                                            controlSize={4}
                                            disabled={true}
                                        />
                                        <Group.Control {...form.appDtlItm.schema.itmSuppQty} disabled={true} />
                                    </Group.Field>
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_PCKG" />
                                    <Group.Field size={4}>
                                        <Group.Control
                                            {...form.appDtlItm.schema.itmPckgUtNm}
                                            controlSize={4}
                                            disabled={true}
                                        />
                                        <Group.Control {...form.appDtlItm.schema.itmPckgQty} disabled={true} />
                                    </Group.Field>

                                    <Group.Control {...form.appDtlItm.schema.origCntyNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItm.schema.itmGwght} align="right" />
                                    <Group.Control {...form.appDtlItm.schema.itmNwght} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItm.schema.currNm} />
                                    <Group.Control {...form.appDtlItm.schema.itmInvcExrt} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_UT_PRC" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...form.appDtlItm.schema.currCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...form.appDtlItm.schema.fobUtVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...form.appDtlItm.schema.fobUtTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_ITM_PRC" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...form.appDtlItm.schema.currCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...form.appDtlItm.schema.itmVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...form.appDtlItm.schema.itmTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_CSTM_VAL" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...form.appDtlItm.schema.currCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...form.appDtlItm.schema.fobVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...form.appDtlItm.schema.fobTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItm.schema.rmrk} controlSize={10} />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                    )}
                    {vhcl && (
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_VHCL"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.chssNo} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclMkerNm} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclMkerMdlNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclCtgrTpNm} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclClrKndNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.engnHpCapc} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclMnfcYy} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclTrmssnTpNm} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.engnNo} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclFlTpNm} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.cyldCnt} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.doorsNo} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.seatCapc} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclPrplTpNm} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclBodyTpNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclKndNm} />
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclAxleNo} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmVhcl.schema.vhclDpacInfoCn} controlSize={10} />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                    )}
                    {frms && (
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_FIRE_ARMS"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.frmsAmtnClsfNm} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.frmsTpNm} />
                                    <Group.Control {...form.appDtlItmFrms.schema.armsCabVal} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.judtPolNm} />
                                    <Group.Control {...form.appDtlItmFrms.schema.orgnCntyNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.frmsMkerNm} />
                                    <Group.Control {...form.appDtlItmFrms.schema.frmsLcneNo} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.cfrRgsrNo} />
                                    <Group.Control {...form.appDtlItmFrms.schema.armsMnfcNo} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.frmsCstmRgsrNo} />
                                    <Group.Control {...form.appDtlItmFrms.schema.frmsRegnRgsrNo} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.pvtWrhsLcneNo} />
                                    <Group.Control {...form.appDtlItmFrms.schema.pvtWrhsLcneHlpnNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmFrms.schema.amtnQty} />
                                    <Group.Control {...form.appDtlItmFrms.schema.amtnDesc} />
                                </Group.Row>

                                <Group.Row></Group.Row>
                            </Group.Section>
                        </Layout>
                    )}
                    {seed && (
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_SEED"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.appDtlItmSeed.schema.cropNm} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmSeed.schema.vrtyNm} />
                                    <Group.Control {...form.appDtlItmSeed.schema.vrtyClsf} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlItmSeed.schema.lotsNo} />
                                    <Group.Control {...form.appDtlItmSeed.schema.vrtyQty} />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                    )}
                    {/* ADD ITEM DETAIL */}
                    {addItm && <APP_DTL_ADD_ITM param={props.state} form={form} area={"ITM"} itemNo={itemNo} />}
                    {/* OFFICER ADD ITEM DETAIL */}
                    {addItm && <APP_RGST_OFCR_ADD_ITM param={props.state} form={form} area={"ITM"} itemNo={itemNo} onOfcrAddItmChange={props.onOfcrAddItmChange} onRegisterTabSave={props.onRegisterTabSave} onRegisterTabValid={props.onRegisterTabValid} />}

                    <Layout direction="row">
                        <Layout.Right>
                            {visible && (
                                <>
                                    <Button
                                        color={"gray"}
                                        onClick={() => {
                                            if(props.ofcrAddItmChanged) {
                                                modal.openModal({content: "msg.osc.00144"}); // Unsaved data exists. Save first and then try again. !== 저장하지 않은 데이터가 존재합니다. 먼저, 저장하고 다시 시도해주시기 바랍니다. ==!
                                                return;
                                            }
                                            handler.setDefaultState();
                                        }}
                                    >
                                        {t("B_ITM_LST")}
                                    </Button>
                                </>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </>
    );
};
